/**
 * DIISEA Footer helpers:
 * - Localization select auto-submit
 * - Desktop: force menu columns open (details/summary is mobile accordion)
 * - Hide sticky ATC while footer is in view
 * - Newsletter: AJAX submit with inline success/error (avoids silent full-page reload)
 * - Theme editor section load/unload safe
 */
(function () {
  var FOOTER_IN_VIEW = 'diisea-footer-in-view';
  var MQ = '(min-width: 768px)';
  var bound = new WeakSet();

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isDesktop() {
    return window.matchMedia && window.matchMedia(MQ).matches;
  }

  function syncMenuDetails(root) {
    var desktop = isDesktop();
    root.querySelectorAll('details.diisea-footer__col').forEach(function (details) {
      if (desktop) {
        details.setAttribute('open', '');
        details.dataset.diiseaForcedOpen = 'true';
      } else if (details.dataset.diiseaForcedOpen === 'true') {
        details.dataset.diiseaForcedOpen = '';
        if (details.dataset.openMobile !== 'true') {
          details.removeAttribute('open');
        }
      }
    });
  }

  function bindLocalization(root) {
    root.querySelectorAll('[data-diisea-footer-auto-submit]').forEach(function (select) {
      if (select.dataset.diiseaBound === 'true') return;
      select.dataset.diiseaBound = 'true';
      select.addEventListener('change', function () {
        if (select.form) select.form.submit();
      });
    });
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function setNewsletterStatus(form, type, message, allowHtml) {
    var status = form.querySelector('[data-diisea-newsletter-status]');
    var fields = form.querySelector('[data-diisea-newsletter-fields]');
    if (!status) return;

    status.hidden = false;
    status.classList.toggle('is-success', type === 'ok');
    status.classList.toggle('is-error', type !== 'ok');

    var body = allowHtml ? String(message) : escapeHtml(message);
    if (type === 'ok') {
      status.innerHTML =
        '<p class="diisea-footer__form-msg diisea-footer__form-msg--ok" role="status">' +
        '<span class="diisea-footer__form-msg-icon" aria-hidden="true">' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" focusable="false">' +
        '<circle cx="12" cy="12" r="11" stroke="currentColor" stroke-width="1.75"/>' +
        '<path d="M7 12.5l3.2 3.2L17 8.8" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg></span>' +
        '<span class="diisea-footer__form-msg-text">' +
        body +
        '</span></p>';
      if (fields) fields.hidden = true;
      form.classList.add('is-subscribed');
      var email = form.querySelector('input[name="contact[email]"]');
      var btn = form.querySelector('[data-diisea-newsletter-submit]');
      if (email) email.disabled = true;
      if (btn) btn.disabled = true;
    } else {
      status.innerHTML =
        '<div class="diisea-footer__form-msg diisea-footer__form-msg--err" role="alert">' +
        body +
        '</div>';
      if (fields) fields.hidden = false;
      form.classList.remove('is-subscribed');
    }

    try {
      status.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'nearest' });
    } catch (e) {
      /* ignore */
    }
  }

  function setNewsletterLoading(form, loading) {
    var btn = form.querySelector('[data-diisea-newsletter-submit]');
    if (!btn) return;
    if (loading) {
      if (!btn.hasAttribute('data-diisea-label')) {
        btn.setAttribute('data-diisea-label', btn.getAttribute('data-label') || btn.textContent.trim());
      }
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('is-loading');
      btn.textContent = 'Subscribing…';
    } else if (!form.classList.contains('is-subscribed')) {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      btn.classList.remove('is-loading');
      btn.textContent = btn.getAttribute('data-diisea-label') || btn.getAttribute('data-label') || 'Subscribe';
    }
  }

  function parseNewsletterResponse(html, formId) {
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var posted =
        /[?&]customer_posted=true/.test(html) ||
        !!doc.querySelector('.diisea-footer__form-msg--ok');
      if (formId) {
        var remoteForm = doc.getElementById(formId);
        if (remoteForm) {
          if (remoteForm.querySelector('.diisea-footer__form-msg--ok')) posted = true;
          var err = remoteForm.querySelector('.diisea-footer__form-msg--err, .errors');
          if (err && err.textContent.trim()) {
            return { ok: false, message: err.innerHTML };
          }
        }
      }
      if (posted) return { ok: true };
      var pageErr = doc.querySelector('.errors');
      if (pageErr && pageErr.textContent.trim()) {
        return { ok: false, message: pageErr.innerHTML };
      }
      return { ok: true };
    } catch (e) {
      return { ok: true };
    }
  }

  function bindNewsletter(root) {
    root.querySelectorAll('form[data-diisea-newsletter]').forEach(function (form) {
      if (form.dataset.diiseaNewsBound === 'true') return;
      form.dataset.diiseaNewsBound = 'true';

      form.addEventListener('submit', function (event) {
        // Theme editor / no fetch: allow native submit
        if (typeof fetch !== 'function' || (window.Shopify && Shopify.designMode)) return;

        event.preventDefault();
        event.stopPropagation();

        if (form.dataset.diiseaSubmitting === '1') return;
        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }

        var successTpl = form.querySelector('[data-diisea-newsletter-success]');
        var successText =
          (successTpl && successTpl.textContent.trim()) ||
          "You're subscribed. Watch your inbox for product updates and offers.";

        form.dataset.diiseaSubmitting = '1';
        setNewsletterLoading(form, true);

        var action = form.getAttribute('action') || '/contact';
        var formData = new FormData(form);

        fetch(action, {
          method: 'POST',
          body: formData,
          credentials: 'same-origin',
          headers: {
            Accept: 'text/html,application/xhtml+xml',
          },
        })
          .then(function (response) {
            var redirectedOk =
              response.redirected &&
              (/customer_posted=true/.test(response.url) || response.ok);
            if (redirectedOk) {
              return { ok: true };
            }
            return response.text().then(function (html) {
              if (!response.ok && response.status >= 400) {
                return {
                  ok: false,
                  message: 'Something went wrong. Please try again.',
                };
              }
              if (/customer_posted=true/.test(response.url)) {
                return { ok: true };
              }
              return parseNewsletterResponse(html, form.id);
            });
          })
          .then(function (result) {
            if (result && result.ok) {
              setNewsletterStatus(form, 'ok', successText, false);
              try {
                sessionStorage.removeItem('the4:recentform');
              } catch (e) {
                /* ignore */
              }
            } else {
              setNewsletterStatus(
                form,
                'err',
                (result && result.message) || 'Please check your email and try again.',
                !!(result && result.message && result.message.indexOf('<') !== -1)
              );
            }
          })
          .catch(function () {
            form.dataset.diiseaSubmitting = '0';
            setNewsletterLoading(form, false);
            HTMLFormElement.prototype.submit.call(form);
          })
          .finally(function () {
            form.dataset.diiseaSubmitting = '0';
            setNewsletterLoading(form, false);
          });
      });
    });
  }

  function bindStickyHide(root) {
    if (!('IntersectionObserver' in window)) return;
    if (root.dataset.diiseaStickyObs === 'true') return;
    root.dataset.diiseaStickyObs = 'true';

    var sticky = document.querySelector('hdt-sticky-btn-atc.diisea-sticky-atc');
    if (!sticky) return;

    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        var inView = !!(entry && entry.isIntersecting && entry.intersectionRatio > 0);
        document.body.classList.toggle(FOOTER_IN_VIEW, inView);
      },
      {
        root: null,
        threshold: [0, 0.01, 0.1],
        rootMargin: prefersReducedMotion() ? '0px' : '0px 0px -8% 0px'
      }
    );

    observer.observe(root);
    root._diiseaFooterIo = observer;
  }

  function bindResize(root) {
    if (root.dataset.diiseaResizeBound === 'true') return;
    root.dataset.diiseaResizeBound = 'true';
    var timer = null;
    function onResize() {
      if (timer) window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        syncMenuDetails(root);
      }, 120);
    }
    window.addEventListener('resize', onResize, { passive: true });
    root._diiseaFooterOnResize = onResize;
  }

  function initRoot(root) {
    if (!root || bound.has(root)) return;
    bound.add(root);

    root.querySelectorAll('details.diisea-footer__col[open]').forEach(function (details) {
      details.dataset.openMobile = 'true';
    });

    bindLocalization(root);
    bindNewsletter(root);
    bindStickyHide(root);
    bindResize(root);
    syncMenuDetails(root);
  }

  function init() {
    document.querySelectorAll('[data-diisea-footer]').forEach(initRoot);
  }

  function destroy(root) {
    if (!root) return;
    if (root._diiseaFooterIo) {
      root._diiseaFooterIo.disconnect();
      root._diiseaFooterIo = null;
    }
    if (root._diiseaFooterOnResize) {
      window.removeEventListener('resize', root._diiseaFooterOnResize);
      root._diiseaFooterOnResize = null;
    }
    root.dataset.diiseaStickyObs = '';
    root.dataset.diiseaResizeBound = '';
    document.body.classList.remove(FOOTER_IN_VIEW);
    bound.delete(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root =
      event.target && event.target.querySelector
        ? event.target.querySelector('[data-diisea-footer]')
        : null;
    if (root) initRoot(root);
    else init();
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root =
      event.target && event.target.querySelector
        ? event.target.querySelector('[data-diisea-footer]')
        : null;
    if (root) destroy(root);
  });
})();
